/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Removed_ToastInputs */



/**
* | output |
* | --- |
* | "Style guide removed successfully" |
*
* @param {Style_Guide_Manager_Removed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_removed_toast = /** @type {((inputs?: Style_Guide_Manager_Removed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Removed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de style supprime avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Styleguide erfolgreich entfernt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida di stile rimossa con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль оформления успешно удален.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía de estilo eliminada con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南已成功移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड सफलतापूर्वक हटा दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia de estilo removido com sucesso")
	return /** @type {LocalizedString} */ ("Style guide removed successfully")
});